// src/components/SearchCips/ToggleSwitch.jsx
import React from "react";
import { Switch } from "@headlessui/react";

const ToggleSwitch = React.memo(
  ({ enabled, setEnabled, districtNameShort }) => {
    return (
      <div className="flex items-center justify-between mt-6 px-4">
        <span className="text-sm font-light text-zinc-600 pr-4">
          Only display {districtNameShort} CIPs
        </span>
        <Switch
          checked={enabled}
          onChange={setEnabled}
          className={`${
            enabled ? "bg-indigo-500" : "bg-zinc-400"
          } relative inline-flex flex-shrink-0 h-[20px] w-[37px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
        >
          <span
            aria-hidden="true"
            className={`${
              enabled ? "translate-x-4" : "translate-x-0"
            } pointer-events-none inline-block h-[16px] w-[16px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
          />
        </Switch>
      </div>
    );
  }
);

export default ToggleSwitch;
